import { getAuthHeaders, tempMeeApi as api } from '~/services/api';
import { IAcceptGoTuTermsPayload, IAcceptGoTuTermsResponse } from './acceptGoTuTermsTypes';

const acceptGoTuTerms = async ({
  officeId,
}: IAcceptGoTuTermsPayload): Promise<IAcceptGoTuTermsResponse> => {
  const headers = await getAuthHeaders();

  const response = await api.post<IAcceptGoTuTermsResponse>(
    '/user/tos/gotu',
    {},
    {
      headers: { ...headers, 'x-office': officeId ?? undefined },
    },
  );

  return response.data;
};

export const acceptGoTuTermsApi = {
  acceptGoTuTerms,
};
